import { notification } from 'antd'
import parseError from 'helpers/parseServerError'
import { javaGetCookieInstance } from 'utils/requestJAVA'
import { apin8nInstance } from 'utils/request'

const IS_PRODUCTION = window.location.hostname === 'backoffice.karmanow.com'
const sheetParam = IS_PRODUCTION ? 'Outstanding Invoices' : 'Collection Agent Tests'

export const getOutstandingInvoices = () => {

  return javaGetCookieInstance
    .get('/admin/v1/outstanding-invoice', {
      params: {
        sheet: sheetParam,
      },
    })
    .catch((error) => {
      return error?.response?.status === 504
        ? notification.error({
            placement: 'bottomRight',
            duration: 10,
            message: 'Java Authentication failed',
            description:
              "Ensure you are accessing BO from the office. All routes that require JAVA won't work properly.",
          })
        : parseError(error, 'Cannot get outstanding invoices')
    })
}

export const updateInvoiceKey = (invoice, newKey) => {
  return javaGetCookieInstance
    .patch(`/admin/v1/outstanding-invoice/${invoice}/key/${newKey}`, null, {
      params: {
        sheet: sheetParam,
      },
    })
    .catch((error) => {
      return parseError(error, 'Cannot update invoice key')
    })
}

export const updateExpectedByEOM = (invoice, expectedByEOM) => {
  return javaGetCookieInstance
    .patch(`/admin/v1/outstanding-invoice/${invoice}/eom/${expectedByEOM}`, null, {
      params: {
        sheet: sheetParam,
      },
    })
    .catch((error) => {
      return parseError(error, 'Cannot update invoice key')
    })
}



export const triggerPayUsOrElse = (record) => {
  return apin8nInstance.post('', {
    invoice: record.invoice,
    description: record.description,
  }).catch((error) => {
    return parseError(error, 'Cannot trigger pay us or else')
  })
}

export const getTotalOutstandingCommission = () => {
  return javaGetCookieInstance
    .get('/admin/v1/outstanding-invoice/totals', {
      params: {
        sheet: 'Total Outstanding commission',
      },
    })
    .catch((error) => {
      return error?.response?.status === 504
        ? notification.error({
            placement: 'bottomRight',
            duration: 10,
            message: 'Java Authentication failed',
            description:
              "Ensure you are accessing BO from the office. All routes that require JAVA won't work properly.",
          })
        : parseError(error, 'Cannot get total outstanding commission')
    })
}